var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { attrs: { xs12: "" } },
    [
      _c("panel", {
        staticClass: "query-panel d-flex fill-height",
        attrs: { "fill-height": "" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_vm._v("\n        Cluster selection\n    ")]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.response,
                    options: _vm.options,
                    "server-items-length": _vm.total,
                    "footer-props": {
                      "items-per-page-options": [10, 20, 50, 100, -1],
                    },
                  },
                  on: {
                    "update:options": function ($event) {
                      _vm.options = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.structure",
                      fn: function (prop) {
                        return [
                          _c(
                            "div",
                            { staticStyle: { "text-align": "left" } },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "cluster",
                                      params: {
                                        cluster: prop.item.intclu_rep_accession,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { height: "75px" },
                                    attrs: {
                                      src: _vm.getImage(
                                        prop.item.intclu_rep_accession
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.pdb_id",
                      fn: function (prop) {
                        return [
                          _c(
                            "div",
                            { staticClass: "align-left" },
                            [
                              _c("ExternalLinks", {
                                attrs: {
                                  accession: prop.value.toUpperCase(),
                                  reference: "PDB",
                                  simple: "",
                                },
                              }),
                              _c("br"),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(prop.item.description) +
                                  "\n                "
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.chains",
                      fn: function (prop) {
                        return [
                          _c("span", [_vm._v(_vm._s(prop.item.chain1))]),
                          _c("br"),
                          _c("span", [_vm._v(_vm._s(prop.item.chain2))]),
                        ]
                      },
                    },
                    {
                      key: "item.uniprot_id",
                      fn: function (prop) {
                        return [
                          _c("div", { staticClass: "align-left" }, [
                            prop.item.uniprot_id1
                              ? _c(
                                  "span",
                                  [
                                    _c("ExternalLinks", {
                                      attrs: {
                                        accession: prop.item.uniprot_id1,
                                        reference: "UniProt",
                                        simple: "",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [_vm._v("N/A ")]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            prop.item.uniprot_id2
                              ? _c(
                                  "span",
                                  [
                                    _c("ExternalLinks", {
                                      attrs: {
                                        accession: prop.item.uniprot_id2,
                                        reference: "UniProt",
                                        simple: "",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", [_vm._v("N/A ")]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "header.lca_tax_id",
                      fn: function ({ header }) {
                        return [
                          _c("TaxonomyAutocomplete", {
                            attrs: {
                              urlFunction: (_, b) => "/search/accession/" + b,
                              disabled: _vm.taxAutocompleteDisabled,
                              options: _vm.requestOptions,
                            },
                            model: {
                              value: _vm.options.tax_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.options, "tax_id", $$v)
                              },
                              expression: "options.tax_id",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "item.lca_tax_id",
                      fn: function (prop) {
                        return [
                          _c("TaxSpan", { attrs: { taxonomy: prop.value } }),
                        ]
                      },
                    },
                    {
                      key: "header.n_mem",
                      fn: function ({ header }) {
                        return [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "offset-y": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g({ attrs: { plain: "" } }, on),
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(header.text) +
                                                "\n                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("RangeSlider", {
                                attrs: { range: _vm.options.n_mem_range },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }